import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  filteredUsers: [],
  searchValue: null,
  selectedUser: {},
  selectedUserRoles: [],
  selectedUserPermissions: {},
  selectedUserRolesPermissions: {},
};

const AdminPanelSlicer = createSlice({
  name: "adminPanel",
  initialState,
  reducers: {
    initUsers: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.users = action.payload;
      state.filteredUsers = action.payload;
    },

    setUsers: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.users = action.payload;
    },

    setFilteredUsers: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.filteredUsers = action.payload;
    },

    setSearchValue: (state, action) => {
      if (typeof action.payload !== "string") return;
      state.searchValue = action.payload;
    },

    setSelectedUser: (state, action) => {
      const payload = action.payload;
      if (typeof payload !== "object") return;
      state.selectedUser = payload;
      state.selectedUserRoles = payload?.roles;
      state.selectedUserPermissions = payload?.permissions;
    },

    setUserRoles: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.selectedUserRoles = action.payload;
    },

    setUserPermissions: (state, action) => {
      if (typeof action.payload !== "object") return;
      state.selectedUserPermissions = action.payload;
    },

    setUserRolesPermissions: (state, action) => {
      const rolesData = action.payload;
      if (!Array.isArray(rolesData)) return;

      if (rolesData.length < 1) {
        state.selectedUserRolesPermissions = {};
        return;
      }

      const mergedPermissions = rolesData.reduce((acc, currentRole) => {
        return {
          ...acc,
          ...currentRole?.data?.permissions,
        };
      }, {});

      state.selectedUserRolesPermissions = mergedPermissions;
    },

    updateUserPermissions: (state, action) => {
      const { newValue, right, page } = action.payload;

      if (
        typeof newValue !== "boolean" ||
        typeof right !== "string" ||
        typeof page !== "string"
      )
        return;
      let pagePermissions = state.selectedUserPermissions?.[page];

      if (!pagePermissions) {
        state.selectedUserPermissions[page] = [];
        pagePermissions = [];
      }

      if (newValue) {
        !pagePermissions.includes(right) && pagePermissions.push(right);
        const mainKey = right.split(":").slice(0, -1).join(":"); // All except the last part of the key
        !pagePermissions.includes(`${mainKey}:view`) &&
          pagePermissions.push(`${mainKey}:view`);
      } else {
        const newPermissions = pagePermissions.filter((p) => p !== right);
        pagePermissions = newPermissions;
      }

      pagePermissions.length > 0
        ? (state.selectedUserPermissions[page] = pagePermissions)
        : delete state.selectedUserPermissions[page];
    },

    updateUserNames: (state, action) => {
      const { firstName, lastName } = action.payload;
      if (typeof firstName !== "string" || typeof lastName !== "string") return;

      state.selectedUser.first_name = firstName;
      state.selectedUser.last_name = lastName;
      state.selectedUser.full_name = `${firstName} ${lastName}`;
    },

    clearSelectedUser: (state) => {
      state.selectedUser = {};
      state.selectedUserRoles = [];
      state.selectedUserPermissions = {};
      state.selectedUserRolesPermissions = {};
    },
  },
});

export const {
  initUsers,
  setUsers,
  setFilteredUsers,
  setSearchValue,
  setSelectedUser,
  setUserRoles,
  setUserPermissions,
  setUserRolesPermissions,
  updateUserPermissions,
  updateUserNames,
  clearSelectedUser,
} = AdminPanelSlicer.actions;

export default AdminPanelSlicer.reducer;
